var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React, { useContext, useEffect } from 'react';
import MessageFooter from '../MessageFooter/MessageFooter';
import pclnExperimentation from '@pcln/experimentation';
import styled from 'styled-components';
import { Animate, Box, Card, ChatMessage, Flex, Image, Link, Relative, Text } from 'pcln-design-system';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { HotelsOutline, FlightsOutline, CarsOutline, PackagesOutline } from '@pcln/brand';
import { products, productsType } from '../../constants';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
var StyledTripsLinkCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "Trips__StyledTripsLinkCard",
  componentId: "sc-xmmhxz-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "Trips__StyledImage",
  componentId: "sc-xmmhxz-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
var CustomTruncate = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Trips__CustomTruncate",
  componentId: "sc-xmmhxz-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var BackUpImage = function (_a) {
  var type = _a.type;
  var IconType;
  if (type === 'STAY') {
    IconType = HotelsOutline;
  } else if (type === 'DRIVE') {
    IconType = CarsOutline;
  } else if (type === 'FLY') {
    IconType = FlightsOutline;
  } else if (type === 'PACKAGE') {
    IconType = PackagesOutline;
  }
  return IconType ? React.createElement(Card, {
    height: '100%',
    borderRadius: '8px',
    borderWidth: 0,
    color: 'primary.light'
  }, React.createElement(Flex, {
    width: ['48px', '88px'],
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(IconType, {
    color: 'primary',
    size: '32px'
  }))) : null;
};
var getCheckStatusUrl = function (checkStatusUrl, shouldUseDeepLink) {
  if (shouldUseDeepLink) {
    var pennyDeepLinkQuestion = encodeURI('I need help with this booking');
    return "".concat(checkStatusUrl, "&openPenny=y&askPrompt=").concat(pennyDeepLinkQuestion);
  }
  return checkStatusUrl;
};
var getPackageTrips = function (trips) {
  var _a = trips || {},
    type = _a.type,
    isExpressDeal = _a.isExpressDeal,
    checkStatusUrl = _a.checkStatusUrl,
    bundleComponents = _a.bundleComponents;
  var firstComponent = bundleComponents[0];
  var lastComponent = bundleComponents[bundleComponents.length - 1];
  var _b = lastComponent || {},
    cityName = _b.cityName,
    stateName = _b.stateName,
    componentType = _b.type;
  var name;
  if (componentType === productsType.DRIVE) {
    name = lastComponent.title;
  } else if (componentType === productsType.FLY) {
    name = "".concat(cityName).concat(stateName ? ", ".concat(stateName) : '');
  } else if (componentType === productsType.FLY) {
    name = lastComponent.subTitle;
  }
  var title = "Trip to ".concat(name);
  var travelStartDate = firstComponent.dateHeader.split('-')[0];
  var travelEndDate = lastComponent.dateHeader.split('-')[1];
  var pkgDateHeader = "".concat(travelStartDate, "-").concat(travelEndDate);
  var pkgType = bundleComponents.reduce(function (accComp, curComp) {
    var type = curComp.type;
    var productName = products[type];
    accComp.push(productName);
    return accComp;
  }, []).join(' + ');
  return {
    type: type,
    isExpressDeal: isExpressDeal,
    checkStatusUrl: checkStatusUrl,
    title: title,
    dateHeader: pkgDateHeader,
    pkgType: pkgType
  };
};
var TripCard = function (_a) {
  var _b;
  var trip = _a.trip,
    shouldUseDeepLink = _a.shouldUseDeepLink;
  var imageSrc, name, productName, brandImageUrl;
  var type = trip.type,
    title = trip.title,
    dateHeader = trip.dateHeader,
    checkStatusUrl = trip.checkStatusUrl;
  name = title;
  var isPackage = type === productsType.PACKAGE;
  if (isPackage) {
    var pkgType = trip.pkgType;
    productName = pkgType;
  } else {
    var rcBrandImageUrl = trip.brandImageUrl,
      type_1 = trip.type,
      header = trip.header,
      imageUrl = trip.imageUrl,
      scheduleInfo = trip.scheduleInfo;
    imageSrc = imageUrl || ((_b = scheduleInfo === null || scheduleInfo === void 0 ? void 0 : scheduleInfo[0]) === null || _b === void 0 ? void 0 : _b.companyLogoUrl);
    productName = products[type_1];
    name = name || header;
    brandImageUrl = rcBrandImageUrl;
  }
  var actualCheckStatusUrl = getCheckStatusUrl(checkStatusUrl, shouldUseDeepLink);
  return React.createElement(Text, {
    lineHeight: '16px'
  }, React.createElement(Card, {
    borderRadius: 16,
    p: 2,
    mb: 2,
    width: 1,
    color: 'background.lightest'
  }, React.createElement(Flex, {
    width: 1
  }, React.createElement(Box, null, React.createElement(Relative, {
    height: '100%',
    width: 1
  }, React.createElement(Flex, {
    height: '100%',
    width: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }, type ? imageSrc ? React.createElement(React.Fragment, null, React.createElement(StyledImage, {
    src: imageSrc,
    width: ['48px', '88px'],
    borderRadius: '8px',
    height: type === 'STAY' ? '100%' : ''
  }), brandImageUrl ? React.createElement(Image, {
    src: brandImageUrl,
    height: '30px',
    width: '60px'
  }) : null) : React.createElement(BackUpImage, {
    type: type
  }) : null))), React.createElement(Flex, {
    flexDirection: 'column',
    pl: 3
  }, productName && React.createElement(Text, {
    color: 'text.light',
    fontSize: 0,
    mb: 1
  }, productName), name && React.createElement(Flex, null, React.createElement(CustomTruncate, {
    fontSize: 1,
    fontWeight: 'bold',
    m: 0,
    mb: 1
  }, name)), dateHeader && React.createElement(Text, {
    fontSize: 0,
    color: 'text',
    mb: 1
  }, dateHeader), actualCheckStatusUrl && React.createElement(Link, {
    target: '_blank',
    href: actualCheckStatusUrl
  }, React.createElement(Text, {
    fontSize: 0
  }, "View Trip"))))));
};
var Trips = function (_a) {
  var tripType = _a.tripType,
    _b = _a.trips,
    trips = _b === void 0 ? [] : _b;
  var setiValues = useContext(ChatbotDataContext).setiValues;
  var showTrips = (trips === null || trips === void 0 ? void 0 : trips.length) && (setiValues === null || setiValues === void 0 ? void 0 : setiValues.displayMyTripsSeti) !== 'DEFAULT';
  var shouldUseDeepLink = (setiValues === null || setiValues === void 0 ? void 0 : setiValues.displayMyTripsSeti) === 'VARIANT_DEEP_LINK';
  useEffect(function () {
    pclnExperimentation.fireImpression('CHATBOT_UPCOMING_TRIPS_CARDS');
  }, []);
  return showTrips ? React.createElement(ChatMessage, {
    ml: '',
    mb: '8px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 2
    }, "I'm happy to help! Below are your ", tripType.toLowerCase(), " trips, please select the one you need help with:"), React.createElement(Box, {
      maxWidth: '450px'
    }, trips.map(function (trip, index) {
      var checkStatusUrl = trip.checkStatusUrl,
        type = trip.type;
      var actualCheckStatusUrl = getCheckStatusUrl(checkStatusUrl, shouldUseDeepLink);
      var isPackage = type === productsType.PACKAGE;
      var key = isPackage ? '' : trip.title || trip.header;
      return React.createElement(Animate, {
        key: key,
        variant: 'slideInLeft',
        override: {
          transition: {
            delay: 0.1 * index || 0
          }
        }
      }, React.createElement(StyledTripsLinkCard, {
        onClick: function () {
          window.open(actualCheckStatusUrl);
        },
        borderWidth: 0,
        width: 1
      }, React.createElement(TripCard, {
        trip: isPackage ? getPackageTrips(trip) : trip,
        shouldUseDeepLink: shouldUseDeepLink
      })));
    }))),
    footer: React.createElement(MessageFooter, null)
  }) : null;
};
export default Trips;
var templateObject_1, templateObject_2, templateObject_3;